'use client'

import { useDecodedAccessToken } from '@b-stock/fe-core/bstock-next/components'
import { usePersonalizationEligibility } from '@b-stock/fe-core/bstock-next/hooks'

const PersonalizationEligibilityCheck = () => {
  usePersonalizationEligibility('/home-portal/api/headers')
  return null
}

/**
 * Resolves and caches personalization eligibility on homepage load, so it
 * doesn't depend on the "Recommended for You" carousel actually rendering
 * (it's conditionally hidden for buyers with no matching categories/listings)
 * or on ListingSearchProvider mounting elsewhere first (BP-2726). Renders
 * nothing. Scoped to the homepage only — not a global, every-page check.
 */
export const HomePersonalizationEligibilityCheck = () => {
  const decodedAccessToken = useDecodedAccessToken()

  if (!decodedAccessToken?.accountId) return null

  return <PersonalizationEligibilityCheck />
}
